import { useFormik } from 'formik';
import { UserValidation } from '@/validations';

export interface AuthorizeUserInitValues {
    username: string;
    captcha: string;
}
export interface VerifyOtpInitValues {
    otp: string;
}
export interface RestPasswordInitValues {
    newPassword: string;
    confirmNewPassword: string;
}

export function useFormAuthorizeUser(onSubmit: (values: AuthorizeUserInitValues, helpers: any) => void) {
    const formik = useFormik<AuthorizeUserInitValues>({
        onSubmit,
        validateOnMount: true,
        validationSchema: UserValidation.AuthorizeUser,
        initialValues: {
            username: '',
            captcha: '',
        },
    });
    return formik;
}

export function userFormVriryOtp(onSubmit: (values: VerifyOtpInitValues, helpers: any) => void) {
    const formik = useFormik<VerifyOtpInitValues>({
        onSubmit,
        validateOnMount: true,
        validationSchema: UserValidation.AuthorizeUser,
        initialValues: {
            otp: '',
        },
    });
    return formik;
}

export function useFormRestPassword(onSubmit: (values: RestPasswordInitValues, helpers: any) => void) {
    const formik = useFormik<RestPasswordInitValues>({
        onSubmit,
        validateOnMount: true,
        validationSchema: UserValidation.AuthorizeUser,
        initialValues: {
            newPassword: '',
            confirmNewPassword: '',
        },
    });
    return formik;
}